import { render } from "./SubscriptionFooter.vue?vue&type=template&id=32477af6&scoped=true"
import script from "./SubscriptionFooter.vue?vue&type=script&lang=js"
export * from "./SubscriptionFooter.vue?vue&type=script&lang=js"

import "./SubscriptionFooter.vue?vue&type=style&index=0&id=32477af6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32477af6"]])

export default __exports__